var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-card',[_c('alert-table')],1),_c('b-card',[_c('merchant-table')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }